"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vue = _interopRequireDefault(require("vue"));
var _vueFragment = _interopRequireDefault(require("vue-fragment"));
_vue.default.use(_vueFragment.default.Plugin);